import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'juno-libs-ui-change-plan-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './change-plan-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePlanSkeletonComponent {}
